// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessPlaceholdersPipe } from '../../../shared/pipes/process-placeholders.pipe';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-at-neocor-applications',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslateModule, ProcessPlaceholdersPipe, AsyncPipe],
  templateUrl: './at-neocor-applications.component.html',
  styleUrl: './at-neocor-applications.component.scss',
})
export class ATNeocorApplicationsComponent implements OnInit {
  atApplicationsLink =
    this.systemOverviewService.atApplicationsLink.lastSuccessfulData$;

  constructor(private systemOverviewService: SystemOverviewService) {}

  ngOnInit(): void {
    this.loadAtApplicationsLink();
  }

  private loadAtApplicationsLink(): void {
    this.systemOverviewService.atApplicationsLink.request();
  }

  public openLink(url: string): void {
    const urlInitial = /^http(s):/;
    if (!urlInitial.exec(url)) {
      url = window.origin + (url.startsWith('/') ? url : '/' + url);
    }
    window.open(url, '_blank');
  }
}
